
        import 'Home.2334dab.css-module'
        export default {"userGroup":"userGroup_Home_2334dab"}
    